import { QUERY_KEY } from "@/constant/queryKey";
import { adminExchangeRateApi, UpdateAdminExchangeRateDto } from "@/services/core/admin-exchange-rate.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hook for updating exchange rate
export function useUpdateExchangeRate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateAdminExchangeRateDto }) =>
      adminExchangeRateApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.ADMIN_EXCHANGE_RATE] });
    },
  });
}
